import { api } from '../api';

export const classroomApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getLocations: builder.query({
            query: (payload) => ({
                url: '/api/location/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            })
        }),
        getTeachers: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'listtchr'
                }
            })
        }),
        getStudents: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'liststuds'
                }
            }),
            providesTags: ['StudentList']
        }),

        getExternalStudents: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'liststudsexternal'
                }
            }),
            providesTags: ['StudentList']
        }),
        getInternalStudents: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'liststudsinternal'
                }
            }),
            providesTags: ['StudentList']
        }),
        getClassrooms: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ClassroomList']
        }),
        getActiveClassrooms: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ClassroomActiveList']
        }),
        getClassroomDetails: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['ClassroomDetails']
        }),

        addUpdateClassroom: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.cls_id ? 'update' : 'create'
                }
            }),
            invalidatesTags: ['ClassroomList', 'ClassroomActiveList', 'ClassroomDetails']
        }),
        deleteClassroom: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DELETE'
                }
            }),
            invalidatesTags: ['ClassroomList', 'ClassroomActiveList']
        }),

        changeClassroomStatus: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'deactivate'
                }
            }),
            invalidatesTags: ['ClassroomList', 'ClassroomActiveList']
        }),

        getClassroomHistory: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'activity'
                }
            }),
            invalidatesTags: ['ClassroomHistory']
        }),

        getSessionClassrooms: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'classroom_by_locations'
                }
            })
        }),

        getSessionCenterTeacher: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'get_all_center_teacher'
                }
            })
        })
    })
});

export const {
    useGetLocationsQuery,
    useGetTeachersQuery,
    useGetStudentsQuery,
    useGetExternalStudentsQuery,
    useGetInternalStudentsQuery,
    useGetClassroomsQuery,
    useGetActiveClassroomsQuery,
    useGetClassroomDetailsQuery,
    useAddUpdateClassroomMutation,
    useDeleteClassroomMutation,
    useChangeClassroomStatusMutation,
    useGetClassroomHistoryQuery,
    useLazyGetClassroomHistoryQuery,
    useGetSessionClassroomsQuery,
    useGetSessionCenterTeacherQuery
} = classroomApi;
